"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _aemReactEditableComponents = require("@adobe/aem-react-editable-components");
var _is_js = require("is_js");
var __jsx = _react.default.createElement;
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    audio: {
      width: '290px',
      outline: 'none',
      '&:focus': {
        outline: 'none'
      }
    }
  };
});
var AudioEditConfig = {
  emptyLabel: 'Audio',
  isEmpty: function isEmpty(props) {
    return !props || !props.src;
  }
};
var Audio = function Audio(_ref) {
  var src = _ref.src,
    type = _ref.type,
    anchorId = _ref.anchorId;
  var classes = useStyles();
  return __jsx(_react.default.Fragment, null, __jsx("audio", {
    id: anchorId,
    className: !(0, _is_js.edge)() && !(0, _is_js.ie)() ? classes.audio : '',
    controls: true,
    controlsList: "nodownload"
  }, __jsx("source", {
    src: src,
    type: type
  })));
};
var _default = (0, _aemReactEditableComponents.MapTo)('cms-commons/components/content/audio')(Audio, AudioEditConfig);
exports.default = _default;